export const CaretDownIcon = (_p: React.ComponentProps<"svg">) => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Caret Down"
  >
    <path
      d="M9.62397 3.375C9.8759 3.375 10.1044 3.55775 10.202 3.83891C10.2997 4.12006 10.245 4.44105 10.0673 4.6566L6.94256 8.40535C6.69844 8.69822 6.30199 8.69822 6.05787 8.40535L2.93314 4.6566C2.75347 4.44105 2.70074 4.12006 2.79839 3.83891C2.89604 3.55775 3.12258 3.375 3.37451 3.375H9.62397Z"
      fill="currentColor"
    />
  </svg>
);
